export default __webpack_public_path__ + "static/media/profile_pic1.bace2d3f.jpg";